import { useQuery } from '@tanstack/react-query'
import { Select, Text } from '@viapeople/components'
import { useState } from 'react'
import { sessionStore } from '../../sharedStores/sessionStore'
import { trpc } from '../../utils/trpc'
import { ManagePdfsTab } from './ManagePdfsTab'

export function ManagePdfsPage() {
	const { user } = sessionStore()
	const [selectedCycleId, setSelectedCycleId] = useState<string>('')

	const { data: cyclesData } = useQuery({
		...trpc.client.dashboard.getCyclesInfo.queryOptions(),
		enabled: !!user?.organizationId,
	})

	const cycles = cyclesData || []
	const cycleOptions = cycles.map((c) => ({
		value: c.id,
		label: c.cycleInfo.name || 'Cycle',
	}))

	return (
		<main data-testid='manage-pdfs-page' className='w-full p-6'>
			<div className='mb-6'>
				<Text data-testid='manage-pdfs-title' variant='h3' weight='semibold'>
					Manage PDFs
				</Text>
				<Text data-testid='manage-pdfs-subtitle' variant='small' className='text-neutral-600 mt-2'>
					Download individual or bulk PDFs for all participants
				</Text>
			</div>

			<div className='mb-4'>
				<div className='min-w-[280px]'>
					<Select
						label='Cycle'
						placeholder={cycleOptions.length ? 'Select cycle' : 'No cycles'}
						options={cycleOptions}
						value={selectedCycleId}
						onChange={(value: string) => setSelectedCycleId(value)}
					/>
				</div>
			</div>

			<div className='border border-neutral-200 bg-neutral-0 rounded-lg shadow-sm'>
				<ManagePdfsTab cycleId={selectedCycleId} />
			</div>
		</main>
	)
}
